export default __webpack_public_path__ + "static/media/Copyrights.e8e12696.svg";